import { ButtonProps, styled } from '@mui/joy';
import { ForwardedRef, forwardRef, useRef } from 'react';

import { Button } from 'core/components';

interface IProps extends Omit<ButtonProps, 'onChange'> {
  text?: string | JSX.Element;
  name?: string;
  onUpload?: (file: File) => void;
  acceptTypes?: string[];
}

const HiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const ButtonFileUpload = forwardRef<HTMLButtonElement, IProps>(function ButtonFileUpload(
  { text, name, onUpload, acceptTypes = [], disabled, ...rest }: IProps,
  ref: ForwardedRef<HTMLButtonElement>
) {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleOnChange = (event) => {
    onUpload(event.target.files[0]);

    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };

  return (
    <Button
      ref={ref}
      component="label"
      role={undefined}
      tabIndex={-1}
      disabled={disabled}
      text={
        <>
          {text}
          {/* Must be disabled together with the label: the visually-hidden input stays focusable,
              so keyboard users could otherwise open the picker while the button looks disabled. */}
          <HiddenInput
            ref={inputRef}
            name={name}
            type="file"
            disabled={disabled}
            onChange={handleOnChange}
            accept={acceptTypes.join(',')}
          />
        </>
      }
      {...rest}
    />
  );
});

export default ButtonFileUpload;
